module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Regular.39ef09b.ttf";